import { render, staticRenderFns } from "./NOVAReport.vue?vue&type=template&id=8ca8fdc8&scoped=true&"
import script from "./NOVAReport.vue?vue&type=script&lang=js&"
export * from "./NOVAReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca8fdc8",
  null
  
)

export default component.exports